module.exports = __webpack_public_path__ + "static/fonts/Pe-icon-7-stroke.39aef4d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.woff?-2irksn
// module id = EofO
// module chunks = 1